import { useOutletContext } from "react-router-dom";

import { AtsDataState, MetricName } from "../../graphql";

type ContextType = {
  selectedOrgId: string;
  setSelectedOrgId: (id: string) => void;
  atsDataState: AtsDataState;
  atsEnabledMetrics: { metricName: MetricName; atsDataState: AtsDataState }[];
  // TODO: Can remove demo dashboard context once old Dashboard is removed
  showBHDemoDashboard: boolean;
  setShowBHDemoDashboard: (show: boolean) => void;
};

const useAnalyticsContext = (): ContextType => {
  return useOutletContext<ContextType>();
};

export default useAnalyticsContext;
